import { render, staticRenderFns } from "./OfflineRecord.vue?vue&type=template&id=fedf7794&scoped=true&"
import script from "./OfflineRecord.vue?vue&type=script&lang=js&"
export * from "./OfflineRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedf7794",
  null
  
)

export default component.exports